import Events from './Events'

const PastEvents = () => <Events isCurrent={false} />
export default PastEvents
